export const THEME_PREFIX = 'ckkblocks'
export const BLOCK_NAME_PREFIX = '[CKKDEV] '; // include a space at the end!
export const PER_PAGE = 15;
